import { render } from "./Patients.vue?vue&type=template&id=41706955&scoped=true&ts=true"
import script from "./Patients.vue?vue&type=script&lang=ts"
export * from "./Patients.vue?vue&type=script&lang=ts"

import "./Patients.vue?vue&type=style&index=0&id=41706955&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41706955"]])

export default __exports__